import { BaseSignalr } from './signalr.js';
import { DefaultDIDListenList, } from './types/index.js';
export class DIDSignalr extends BaseSignalr {
    constructor(options) {
        const { listenList = DefaultDIDListenList } = options || {};
        super({ listenList });
    }
    Ack(clientId, requestId) {
        this.invoke('Ack', clientId, requestId);
    }
    onCaAccountRegister({ clientId, requestId }, callback) {
        return this.listen('caAccountRegister', (data) => {
            if (data.requestId === requestId) {
                if (data.body.registerStatus !== 'pending') {
                    this.Ack(clientId, requestId);
                }
                callback(data);
            }
        });
    }
    onCaAccountRecover({ clientId, requestId }, callback) {
        return this.listen('caAccountRecover', (data) => {
            if (data.requestId === requestId) {
                if (data.body.recoveryStatus !== 'pending') {
                    this.Ack(clientId, requestId);
                }
                callback(data);
            }
        });
    }
    onScanLoginSuccess(callback) {
        return this.listen('onScanLoginSuccess', (data) => {
            if (typeof (data === null || data === void 0 ? void 0 : data.body) === 'string') {
                callback(data);
                this.stop();
            }
        });
    }
    onScanLogin(callback) {
        return this.listen('onScanLogin', (data) => {
            if (typeof (data === null || data === void 0 ? void 0 : data.body) === 'string') {
                callback(data);
                this.stop();
            }
        });
    }
}
